import { useEffect } from "react";
import { VStack, LightMode } from "@chakra-ui/react";
import Page from "~/components/Page";
import Header from "~/components/marketing/Header";
import Footer from "~/components/marketing/Footer";
import SupportSectionChannels from "~/components/marketing/support/SupportSectionChannels";
import SupportSectionFaq from "~/components/marketing/support/SupportSectionFaq";
import LandingSectionLargeCallToAction from "~/components/marketing/landing/LandingSectionLargeCallToAction";

export default function SupportPage() {
  // Initialize Crisp Chat
  useEffect(() => {
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = "faafb953-7f75-488f-94fa-4d53c773e52e";

    var d = document;
    var s = d.createElement("script");

    s.src = "https://client.crisp.chat/l.js";
    s.async = 1;
    d.getElementsByTagName("head")[0].appendChild(s);
  }, []);

  return (
    <Page
      title="Precios | Shop Story"
      description="Te acompañamos en la creación de tu negocio. Soporte vía WhatsApp, Email o Chat. Aprendé a emprender y recibí ayuda en nuestra comunidad de negocios."
    >
      <LightMode>
        <VStack
          w="100%"
          maxW="100vw"
          overflowX="hidden"
          spacing="0"
          align="flex-start"
          backgroundColor="light.background.superLite"
        >
          <Header />
          <SupportSectionChannels />
          <SupportSectionFaq />
          <LandingSectionLargeCallToAction />
          <Footer />
        </VStack>
      </LightMode>
      <style global jsx>{`
        html,
        body {
          background-color: #ffffff;
        }
      `}</style>
    </Page>
  );
}
